// extracted by mini-css-extract-plugin
export var addressAddress = "detailsAddress-module--address-address--7e9c6";
export var addressBody = "detailsAddress-module--address-body--053da";
export var addressCarouselContainer = "detailsAddress-module--address-carousel-container--acab1";
export var addressContact = "detailsAddress-module--address-contact--86050";
export var addressContent = "detailsAddress-module--address-content--4ae1b";
export var addressContentContainer = "detailsAddress-module--address-content-container--6262f";
export var addressFooter = "detailsAddress-module--address-footer--821ac";
export var addressFooterBack = "detailsAddress-module--address-footer-back--b2ae8";
export var addressMail = "detailsAddress-module--address-mail--bdb39";
export var addressPlace = "detailsAddress-module--address-place--d51a9";
export var addressPlaceIcon = "detailsAddress-module--address-place-icon--0865e";
export var addressPlaceTitle = "detailsAddress-module--address-place-title--2e5f6";
export var addressTel = "detailsAddress-module--address-tel--753a1";
export var addressTitle = "detailsAddress-module--address-title--e7519";
export var editButton = "detailsAddress-module--edit-button--f3a4a";
export var pageAddress = "detailsAddress-module--page-address--4174b";
export var pageAddressAdditionalInfos = "detailsAddress-module--page-address-additional-infos--a2382";
export var resultMore = "detailsAddress-module--result-more--a84d3";
export var separator = "detailsAddress-module--separator--08c39";